<template>
  <v-card>

    <v-data-table :headers="headers"
                  :items="scormCourses"
                  :options.sync="options"
                  :footer-props="dataTableFooterProps"
                  :server-items-length="totalScormCourses"
                  :loading="scormCoursesLoading"
                  disable-sort
                  loading-text="Loading... Please wait">

      <template v-slot:top>
        <v-card-title class="grey--text text--darken-2">
          <v-icon class="mx-3">
            mdi-file-cabinet
          </v-icon>
          Shareable Content Object Reference Model (SCORM)
        </v-card-title>

        <v-card-title class="mb-10">

          <v-btn class="mr-5 ml-2"
                 rounded
                 color="primary"
                 dark
                 x-large
                 @click="addItem()"
          >
            <v-icon
            >
              mdi-plus
            </v-icon>
            Add a SCORM
          </v-btn>

          <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search SCORM"
              single-line
              hide-details
              filled
              rounded
              placeholder="Search SCORM"
              class="mr-5"
              clearable
              @click="clear"
              color="primary"
          ></v-text-field>

          <RefreshTableHeader :action="refresh" />

        </v-card-title>
      </template>

      <template v-slot:item.actions="{ item }">
        <v-btn x-small
               depressed
               class="pa-3 ma-1"
               @click="editItem(item)">
          <v-icon small>
            mdi-pencil
          </v-icon>
        </v-btn>

        <v-btn
            x-small
            depressed
            @click="deleteItem(item)"
            class="pa-3 ma-1">
          <v-icon small color="primary">
            mdi-close
          </v-icon>
        </v-btn>
      </template>

      <template v-slot:[`footer.page-text`]="items">
        <RefreshTableFooter :item="items" :action="refresh"/>
      </template>

    </v-data-table>
    <ScormAdd/>
    <ScormEdit/>
    <ScormDelete/>

  </v-card>
</template>

<script>
import { mapGetters, mapState, mapActions } from "vuex";
import ScormAdd from "@/components/Scorm/ScormAdd";
import RefreshTableHeader from "@/components/common/RefreshTableHeader";
import RefreshTableFooter from "@/components/common/RefreshTableFooter";
import {debounce} from "@/utility";
import ScormDelete from "./Scorm/ScormDelete";
import ScormEdit from "./Scorm/ScormEdit";

export default {
  name: "Scorm",
  components: {ScormEdit, ScormDelete, RefreshTableHeader, RefreshTableFooter, ScormAdd},
  computed: {
    ...mapState([
      'scormCoursesLoading', 'totalScormCourses',
    ]),
    ...mapGetters(['scormCourses', 'scormCoursesLoading', 'totalScormCourses', 'dataTableFooterProps']),
  },
  methods: {
    ...mapActions([
      'getScormCourses', 'getScormCourse', 'clearScormCourseApiError', 'setOpenDialog',
      'setScormCoursesPaginationOptions', 'setScormCoursesSearch',
    ]),
    addItem() {
      this.clearScormCourseApiError();
      this.setOpenDialog('scormAdd');
    },
    async editItem(item) {
      this.clearScormCourseApiError();
      this.setOpenDialog('scormEdit');
      await this.getScormCourse(item);
      if (!this.currentScormCourseItem) {
        this.getScormCourses();
      }
    },
    async deleteItem(item) {
      this.clearScormCourseApiError();
      this.setOpenDialog('scormDelete');
      await this.getScormCourse(item);
      if (!this.currentScormCourseItem) {
        this.getScormCourses();
      }
    },
    refresh() {
      this.getScormCourses();
    },
    clear() {
      this.setScormCoursesSearch('');
    },
  },
  mounted () {
    this.setScormCoursesSearch('');
    this.getScormCourses();
  },
  data() {
    return {
      search: '',
      debouncedSearch: '',
      options: {
        itemsPerPage: 10,
      },
      headers: [
        {
          text: 'ID',
          align: 'start',
          value: '_id',
        },
        {
          text: 'Original Name',
          align: 'start',
          value: 'originalName',
        },
        {
          text: 'Course ID',
          align: 'start',
          value: 'courseId',
        },
        {
          text: 'Completed',
          align: 'start',
          value: 'completed',
        },
        {
          text: 'Version',
          align: 'start',
          value: '__v',
        },
        {
          text: 'Created',
          align: 'start',
          value: 'createdAt',
        },
        {
          text: 'Updated',
          align: 'start',
          value: 'updatedAt',
        },
        {
          text: 'Actions',
          value: 'actions',
          sortable: false,
        },
      ],
    };
  },
  watch: {
    options: {
      handler() {
        this.setScormCoursesPaginationOptions(this.options);
        this.getScormCourses();
      },
      deep: true,
    },
    search: debounce(function(newVal) {
      this.debouncedSearch = newVal;
    }, 500),
    debouncedSearch: {
      handler() {
        this.setScormCoursesSearch(this.search ?? '');
        this.getScormCourses();
      },
    },
  },
};
</script>
